import React, { useState } from "react";
import "./sidebar.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Image_Url } from '../../constants/imageUrl/ImageUrl';
import { buttonHandleAction, tutorialSearchInputAction, tutorialListPageinputAction } from "../../actions/trainingAction";
import { pageinputAction, searchinputAction, pgmFilterButtonAction } from "../../actions/pgmAction";
import { partlistSearchInput, partlistPageValue } from "../../actions/partAction";
import { useTranslation } from "react-i18next";
import { hasAnyPermission, hasPermission } from "../../utils/permissionUtils";
import { PERMISSIONS } from "../../constants/permissions/Permissions";

const Sidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const routerEndPoint = process.env.REACT_APP_ROUTE_ENDPOINT || ""
  const formattedRouteEndpoint = routerEndPoint.replace(/\/+$/, "");

  const handleProductTrainingClick = () => {
    if (hasAnyPermission([PERMISSIONS.CAN_VIEW_TRAINING_TUTORIALS, PERMISSIONS.CAN_VIEW_TRAINING_MODULE])) {
      navigate('/productTraining')
    }
    var btnvalue = {
      activebtn: "Tutorial",
      training: true,
      module: false
    };
    dispatch(tutorialListPageinputAction(1));
    dispatch(buttonHandleAction(btnvalue));
    var seardata = {
      searchdata: "",
      type: "",
    };
    dispatch(tutorialSearchInputAction(seardata));
  }
  const handlepgmlistTabClick = () => {
    if (hasPermission(PERMISSIONS.CAN_VIEW_PGM_LIST)) {
      navigate('/pgmlist');
    } else if (hasPermission(PERMISSIONS.CAN_CREATE_PGM_USER)) {
      navigate('/partner');
    }
    window.scroll(0, 0);
    dispatch(pageinputAction(1));
    var seardata = {
      value: "",
    };
    dispatch(searchinputAction(seardata));
    dispatch(pgmFilterButtonAction("pending"));
  }
  const handlepartsandorderTabClick = () => {
    if (hasPermission(PERMISSIONS.CAN_VIEW_ORDERS)) {
      navigate("/partorderlist");
    } else if (hasPermission(PERMISSIONS.CAN_VIEW_PARTS)) {
      navigate("/partslist");
    } else if (hasPermission(PERMISSIONS.CAN_VIEW_PART_CATALOGUES)) {
      navigate("/partcatelogue");
    }
    window.scroll(0, 0);
    dispatch(partlistPageValue(1));
    var seardata = {
      vehicle: "",
      value: "",
    };
    dispatch(partlistSearchInput(seardata));
  }

  const handleRolesAndPermission = () => {
    navigate('/roles_and_permission')
  }

  const handleNotificationList = () => {
    navigate('/notification_list')
  }

  return (
    <div className="SidebarConatiner">
      {hasAnyPermission([PERMISSIONS.CAN_VIEW_PGM_LIST, PERMISSIONS.CAN_CREATE_PGM_USER]) && (
        <div
          onClick={handlepgmlistTabClick}
          className={
            "SideBarbox " +
            (window.location.pathname === `${formattedRouteEndpoint}/pgmlist` || window.location.pathname === `${formattedRouteEndpoint}/partner` ? "active" : "")
          }
        >
          <img className="sideimage" src={Image_Url.PGMLIST} alt="ProfilesInfo" />
          <span>{t('sidebar.pgmlist')}</span>
        </div>
      )}
      {hasAnyPermission([PERMISSIONS.CAN_VIEW_PARTS, PERMISSIONS.CAN_VIEW_ORDERS, PERMISSIONS.CAN_VIEW_PART_CATALOGUES, PERMISSIONS.CAN_CREATE_PART]) && (
        <div
          className={
            "SideBarbox " +
            (window.location.pathname === `${formattedRouteEndpoint}/partslist` ||
              window.location.pathname === `${formattedRouteEndpoint}/partorderlist` ||
              window.location.pathname === `${formattedRouteEndpoint}/partcatelogue` ||
              window.location.pathname === `${formattedRouteEndpoint}/addparts`
              ? "active"
              : "")
          }
          onClick={handlepartsandorderTabClick}
        >
          <img className="sideimage" src={Image_Url.PGMDEALERS} alt="ProfilesInfo" />
          <span>{t('sidebar.partsandorder')}</span>
        </div>
      )}
      {hasAnyPermission([PERMISSIONS.CAN_VIEW_TRAINING_TUTORIALS, PERMISSIONS.CAN_VIEW_TRAINING_MODULE]) && (
        <div
          className={
            "SideBarbox " +
            (window.location.pathname === `${formattedRouteEndpoint}/productTraining` || window.location.pathname === `${formattedRouteEndpoint}/addeditmodule` || window.location.pathname === `${formattedRouteEndpoint}/addmoduleconfirmation` ? "active" : "")
          }
          onClick={handleProductTrainingClick}
        >
          <img className="sideimage" src={Image_Url.PRODUCTTRAINING} alt="ProfilesInfo" />
          <span>{t('sidebar.producttraining')}</span>
        </div>
      )}
      {hasAnyPermission([PERMISSIONS.CAN_VIEW_AREA_EXECUTIVES, PERMISSIONS.CAN_VIEW_ADMIN_USERS]) && (
        <div
          className={
            "SideBarbox " +
            ([
              `${formattedRouteEndpoint}/roles_and_permission`,
              `${formattedRouteEndpoint}/add_area_executive`,
              `${formattedRouteEndpoint}/create_role`,
              `${formattedRouteEndpoint}/create_user`,
              `${formattedRouteEndpoint}/user_management`,
            ].includes(window.location.pathname) ||
              [`${formattedRouteEndpoint}/edit_role`, `${formattedRouteEndpoint}/edit_user`, `${formattedRouteEndpoint}/edit_area_executive`]
                .some(path => window.location.pathname.startsWith(path))
              ? "active"
              : "")
          }
          onClick={handleRolesAndPermission}
        >
          <img className="sideimage" src={Image_Url.MANAGETEAMS} alt="ProfilesInfo" />
          <span>{t('sidebar.rolesAndUsers')}</span>
        </div>
      )}

      {/* <div
        className={
          "SideBarbox " +
          (window.location.pathname === `${formattedRouteEndpoint}/notification_list` || window.location.pathname === `${formattedRouteEndpoint}/create-notification` || window.location.pathname === `${formattedRouteEndpoint}/create-notification-excel` ? "active" : "")
        }
        onClick={handleNotificationList}
      >
        <img className="sideimage" src={Image_Url.NOTIFICATIONICON} alt="ProfilesInfo" />
        <span>{t('sidebar.notification')}</span>
      </div> */}

    </div>
  );
};
export default Sidebar;
